import { ROUTES } from '@app/constants'

export const getBookingUrl = (zipCode: string) => {
  const obfuscatedZip = btoa(zipCode)
  return `${ROUTES.booking}?z=${obfuscatedZip}`
}
